<template>
  <div>
    <v-dialog width="500px" style="background-color: white" v-model="suspendingUser" v-if="suspendingUser">
      <BanConfirmation @close="suspendingUser = false" :suspend="!AppUsers.AccountDisabled" @messageSaved="handleUser" />
    </v-dialog>
    <v-col cols="12" sm="12" md="12"></v-col>
    <v-row justify="center" justify-sm="end" style="margin: 5px">
      <v-col cols="12" sm="12" md="2">
        <v-row justify="center" justify-sm="end" style="padding: 10px">
          <v-btn @click="goToPage('/messageUser')" class="btn" dark>
            Message
          </v-btn>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="2">
        <v-row justify="center" justify-sm="end" style="padding: 10px">
          <v-btn @click="suspendingUser = true" class="white--text confirm-btn">
            {{ buttonText }} User
          </v-btn></v-row>
      </v-col>
      <v-col cols="12" sm="12" md="2">
        <v-row justify="center" justify-sm="end" style="padding: 10px">
          <v-btn @click="goBack()" flat class="back">Back</v-btn>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-expansion-panels accordion flat style="margin-bottom: -5%">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="card1">Personal Info</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="card">
              <v-col cols="12" sm="12" md="5" style="padding: 2%">
                <div class="header">Name</div>
                <v-text-field readonly v-model="AppUsers.name" solo outlined dense placeholder="">
                </v-text-field>
                <div class="header">Surname</div>
                <v-text-field solo outlined dense placeholder="" readonly v-model="AppUsers.lastname">
                </v-text-field>
                <div class="header">Email Address</div>
                <v-text-field solo dense outlined placeholder="" readonly v-model="AppUsers.email">
                </v-text-field>
                <div class="header">Contact No.</div>
                <v-text-field solo dense outlined placeholder="" readonly v-model="AppUsers.mobile">
                </v-text-field>
              </v-col>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-row style="padding-top: 4%" justify="center" align="center" v-for="medInfo in medicalInfo" :key="medInfo">
      <v-expansion-panels accordion flat style="margin-bottom: %">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="card1">Medical info</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="card">
              <v-col cols="12" sm="12" md="5" style="padding: 2%">
                <div class="header">Age</div>
                <v-text-field solo outlined dense placeholder="" readonly v-model="medInfo.age">
                </v-text-field>
                <div class="header">Blood Type</div>
                <v-text-field solo outlined dense placeholder="" readonly v-model="medInfo.blood_grp">
                </v-text-field>
                <div class="header">Height</div>
                <v-text-field solo dense outlined placeholder="" readonly v-model="medInfo.height">
                </v-text-field>
                <div class="header">Weight</div>
                <v-text-field solo dense outlined placeholder="" readonly v-model="medInfo.weight">
                </v-text-field>
              </v-col>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-col cols="12" v-if="userType == 'App  11'">
      <v-row justify="center" style="padding: 1%; margin-top: 10px">
        Emergency Contact
      </v-row>
      <v-row justify="center" align="center">
        <v-data-table :headers="headers" :items="emergencyContacts" :item-per-page="10" :search="search"
          :sort-by="headers" hide-default-footer class="dark-text" :loading="loading"
          loading-text="Loading... Please wait">
        </v-data-table>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import BanConfirmation from "../components/BanConfirmation.vue";
import {
  collection,
  getDocs,
  getFirestore,
  where,
  setDoc,
  doc,
  query,
} from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);
import { debounce } from "../helpers.js";
export default {
  name: "App",
  components: { Navbar, BanConfirmation },
  data() {
    return {
      medicalInfo: [],
      emergencyContacts: [],
      reg_number: "",
      age: "",
      blood_grp: "",
      height: "",
      weight: "",
      AppUsers: null,
      allUsers: [],
      search: "",
      suspendingUser: false,
      isloading: false,
      AppUsers: {
        AccountDisabled: false,
      },
      savingUser: false,
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => /^[a-zA-Z ]*$/.test(v) || "Name can only contain letters",
      ],
      contactRules: [
        (v) => !!v || "Contact is required",
        (v) =>
          /^\d{10}$/.test(v) || "Contact must be valid number with 10 digits",
      ],
      headers: [
        { text: "Name", value: "name", sortable: true },
        { text: "username", value: "username", sortable: true },
        { text: "Email Address", value: "email", sortable: true },
      ],
      userType: "",
      suspendMessage: "",
    };
  },
  methods: {
    openSaveDialog() {
      this.savingUser = !this.savingUser;
    },
    // Method to fetch a users medical info
    async getMedicalInfo() {
      this.loading = true;
      try {
        const q = query(
          collection(db, "user_medical_details"),
          where("reg_number", "==", this.AppUsers.mobile)
        );

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let tempInfo = doc.data();

          tempInfo.id = doc.id;

          this.medicalInfo.push(tempInfo);
        });
      } catch (error) { }
    },
    // Method to fetch a users emergency contacts
    async getEmergencyContacts() {
      try {
        const q = query(
          collection(db, "emergency_contact"),
          where("reg_number", "==", this.AppUsers.mobile)
        );

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          let tempInfo = doc.data();

          tempInfo.id = doc.id;

          this.emergencyContacts.push(tempInfo);
        });
        this.loading = false;
      } catch (error) { }
    },
    goToPage(path) {
      this.$router.push({ path });
    },
    // Method to go back to the previous page
    goBack() {
      let userType = localStorage.getItem("userType");

      if (userType == "App") {
        this.$router.push({ path: "/users", query: { type: "App" } });
      } else if (userType == "Dashboard") {
        this.$router.push({ path: "/users", query: { type: "Dashboard" } });
      }
    },
    // Method to log the AppUsers block event to audit trail
    async logBlockEvent() {
      let action;

      if (this.AppUsers.AccountDisabled) {
        action = "Unblocked";
      } else {
        action = "Blocked";
      }

      let newEvent = {
        date: Math.floor(new Date().getTime() / 1000),
        eventType: "User Management",
        eventAction: "User " + action,
        AppUsers: localStorage.getItem("mobile"),
      };

      await addDoc(collection(db, "events"), newEvent)
        .then(async (res) => { })
        .catch((error) => {
          console.log(error);
        });
    },
    // Method to assign the custom suspend method if other is selected 
    handleUser(message) {
      if (message) {
        this.suspendMessage = message;
      }

      this.toggleAccount(this.AppUsers);
    },
    // Method to block/unblock AppUsers
    async toggleAccount(item) {
      let disabled;

      if (!item.AccountDisabled) {
        disabled = true;
      } else {
        disabled = false;
      }

      let newUser = {
        name: item.name,
        lastname: item.lastname,
        email: item.email,
        mobile: item.mobile,
        AccountDisabled: disabled,
      };

      if (disabled == true) {
        newUser.suspendReason = this.suspendMessage;
      }

      if (item.paid) {
        newUser.paid = item.paid;
      } else {
        newUser.paid = false;
      }

      if (item.city) {
        newUser.city = item.city;
      }

      if (item.suburb) {
        newUser.suburb = item.suburb;
      }

      if (item.latitude) {
        newUser.latitude = item.latitude;
      }

      if (item.longitude) {
        newUser.longitude = item.longitude;
      }

      if (item.profileImage) {
        newUser.profileImage = item.profileImage;
      }

      if (item.suspendReason) {
        newUser.suspendReason = item.suspendReason;
      }

      console.log("newUser: ", newUser);

      let path;

      if (this.userType == "App") {
        path = "AppUsers";
      } else {
        path = "users";
      }

      await setDoc(doc(db, path, item.id), newUser)
        .then((res) => {
          this.savingUser = false;
          this.successMessage = "Successfully disabled AppUsers!";
          this.success = true;
          that.success = false;
          that.goBack();
          this.sendEmail(item, disabled);

          console.log("Res: ", res);
        })
        .catch((error) => {
          console.log(error);
          this.savingUser = false;
          this.errorMessage = "Failed to disable AppUsers, please try again!";
          this.displayErrorMessage();
        });
    },
    // Method to send an email to a AppUsers upon blocking/unblocking
    sendEmail(item, block) {
      let body = JSON.stringify({
        email: item.email,
        firstName: item.name,
        block: block,
      });

      fetch(
        "https://europe-west2-propertygroupapp.cloudfunctions.net/sendEmailReceipt",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: body,
        }
      )
        .then((response) => {
          response.json();
        })
        .then((response) => {
          console.log(JSON.stringify(response));
          this.logBlockEvent();
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
  },
  created() {
    this.userType = localStorage.getItem("userType");

    this.AppUsers = JSON.parse(localStorage.getItem("viewedUser"));

    if (this.userType == "App") {
      this.getMedicalInfo();
      this.getEmergencyContacts();
    }
  },
  computed: {
    color() {
      return this.condition ? "red" : "white";
    },
    buttonText() {
      if (this.AppUsers.AccountDisabled) {
        return "Activate";
      } else {
        return "Disable";
      }
    },
  },
};
</script>

<style scoped>
.confirm-btn {
  border-radius: 20px;
  background-color: #4b4b4b;
  width: 100%;
}

.card1 {
  box-shadow: 0px 0px 0px 1px black;
  background-color: black;

  width: 100%;
  border-radius: 12px 12px 0px 0px;
  color: white;
  text-align: center;
  padding: 15px;
}

.card {
  box-shadow: 0px 0px 0px 1px black;

  width: 100%;
  border-radius: 0px 0px 12px 12px;
  text-align: center;
}

.header {
  text-align: left;
}

.v-text-field {
  min-height: "20px";
  height: 70px;
}

.v-btn {
  margin-left: 2%;
}

.btn {
  background: linear-gradient(0deg,
      rgba(0,129,128,255) 0%,
      rgba(0,129,128,255) 100%);
  border-radius: 20px;
  width: 100%;
}

.dark-text {
  width: 95%;
  margin-top: 30px;
}

.back {
  border-radius: 15px;
  box-shadow: 0px 0px 0px 1px black;
  width: 100%;
}
</style>
